export default "__VITE_ASSET__85d86182__"